import React, { useState } from "react";
import { Nav, Navbar, Container, NavDropdown } from "react-bootstrap";
import { FaUserCircle } from "react-icons/fa";
import OffCanvas from "./OffCanvas";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";

const NavbarComp = () => {
  const navigate = useNavigate();

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const logout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You will be logged out!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Logout!",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        sessionStorage.clear();

        Swal.fire({
          icon: "success",
          title: "Logged Out",
          text: "You have been logged out successfully.",
          confirmButtonText: "OK",
        }).then(() => {
          navigate("/login");
        });
      }
    });
  };

  return (
    <>
      <Navbar
        style={{
          background: "white",
          borderColor: "gray",
          padding: "2px",
        }}
        bg=""
        expand="lg"
        sticky="top"
      >
        <Container fluid>
          <Navbar.Brand
            id="navbarScroll"
            style={{
              color: "green",
              marginLeft: "0px",
              marginRight: "5px",
              cursor: "pointer",
            }}
            onClick={handleShow}
          >
            <img
              src="logo-yarsi.png"
              width="30"
              height="30"
              className="d-inline-block align-top"
              alt="Toko Logo"
            />
          </Navbar.Brand>

          <Nav
            className="me-auto my-3 my-lg-0"
            style={{ maxHeight: "100px" }}
            navbarScroll
          ></Nav>
          <Navbar.Toggle aria-controls="navbarScroll" />
          <Navbar.Collapse id="navbarScroll">
            <Nav
              className="me-auto my-1 my-lg-0"
              style={{ maxHeight: "100px" }}
              navbarScroll
            ></Nav>
            <Nav.Link
              style={{
                color: "gray",
                marginLeft: "10px",
                marginRight: "10px",
                fontWeight: 700,
              }}
              className="p-1"
              href="#"
            >
              <FaUserCircle size={25} />
            </Nav.Link>

            <NavDropdown
              align="end"
              style={{
                fontWeight: 700,
                color: "gray",
                marginLeft: "0px",
                marginRight: "0px",
              }}
              className="p-1"
              id="navbarScrollingDropdown"
            >
              <NavDropdown.Item onClick={logout}>logout</NavDropdown.Item>
            </NavDropdown>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <OffCanvas show={show} handleClose={handleClose} />
    </>
  );
};

export default NavbarComp;
